import { Authority,getBolb} from '../request'

const { get,post} = Authority

//下载整改通知书文件
export const downloadRectificationNoticeDoc = params => getBolb('/investigate/rectification-notice/v1/generateDoc', { params })
//下载整改通知书回复文件
export const downloadRectificationNoticeBackDoc = params => getBolb('/investigate/rectification-notice/v1/generateBackDoc', { params })
//下载督查通知书
export const downloadSuperviseNoticeDoc = params => getBolb('/supervise/supervise-notice/v1/generateDoc', { params })
//下载督查整改回复通知书
export const downloadSuperviseNoticeBackDoc = params => getBolb('/supervise/supervise-notice/v1/generateBackDoc', { params })
//下载边坡排查doc
export const downloadSlopePaiChaDoc = params => getBolb('/investigate/investigate-slope-order/v1/generateDoc', { params })

//查询建设单位考核列表
export const getAssessmentList = params => get('/assessment/investigate-assessment-order/v1/queryList', { params })

//查询施工单位考核列表
export const getAssessmentShiGongList = params => get('/assessment/investigate-assessment-order/v1/queryByParentId', { params })



// 数据看板-新增数据轮播
export const getDamageInfoList = params => get('/statistics/investigate/v1/damageInfo', { params })
// 基础数据统计
export const getBaseStatistics = params => get('/statistics/investigate/v1/baseInfo', { params })
// 隐患类型统计
export const getInvestigateTypeStatistics = params => get('/statistics/investigate/v1/damageCount', { params })
// 获取隐患地图
export const getInspectionMap = params => get('/statistics/investigate/v1/map', { params })
// 风险等级占比图
export const getRiskLevelStatistics = params => get('/statistics/investigate/v1/riskLevelCount', { params })
//近七日日常排查统计
export const getWeekCountStatistics = params => get('/statistics/investigate/v1/dailyCount', { params })





// 获取标段关联排查单列表
export const getInvestigationList = params => get('/investigate/rectification-notice/v1/queryInvestigateListByRoadSectionId', { params })

// 获取边坡排查单详情
export const getSlopeInvestigationDetail = params => get('/investigate/investigate-slope-order/v1/queryById', { params })

// 获取公路排查单详情
export const getRoadInvestigationDetail = params => get('/investigate/investigate-road-order/v1/queryById', { params })

// 下发整改通知单
export const addRectificationNotice = params => post('/investigate/rectification-notice/v1/add',  params )
// 查询通知单列表
export const getNoticeList = params => get('/investigate/rectification-notice/v1/queryList', { params })
// 获取通知单关联排查单列表
export const getNoticeInvestigateList = params => get('/investigate/rectification-notice/v1/queryInvestigateListByNoticeId', { params })
// 排查通知单签收
export const receiveRectificationNotice = params => post('/investigate/rectification-notice/v1/receive',  params )
// 通知单上报
export const upRectificationNotice = params => post('/investigate/rectification-notice/v1/up',  params )
// 上报单改为停工通知单
export const stopRectificationNotice = params => post('/investigate/rectification-notice/v1/update',  params )
//添加督查报告
export const addInspectionNotice = params => post('/supervise/supervise-notice/v1/add',  params )
//下发警告函或抽查意见书到建设单位
export const addWarningNotice= params => post('/supervise/supervise-notice/v1/update',  params )
//下发警告函或抽查意见书到施工单位和监理单位
export const downWarningNotice= params => post('/supervise/supervise-notice/v1/down',  params )
// 获取督查列表
export const getInspectionNoticeList = params => get('/supervise/supervise-notice/v1/queryList', { params })
// 获取建设单位下的 单位列表
export const getUnitList= params => get('/user/userLogin/v1/checkSelectList', { params })
//监管单位通知书销号
export const cancelRectificationNotice2= params => post('/supervise/supervise-notice/v1/check',  params )
// 获取边坡id对应的排查列表
export const getSlopeInvestigateListByBaseId= params => get('/investigate/investigate-slope-order/v1/queryBySlopeId', { params })
export const getDamageInvestigateListByBaseId= params => get('/investigate/investigate-road-order/v1/queryByDamageId', { params })


// 销号
export const cancelRectificationNotice = params => post('/investigate/rectification-notice/v1/check',  params )


// 获取边坡排查清单项
export const getSlopeInvestigateList = params => get('/investigate/investigate-slope/v1/queryList', { params })

// 新增边坡排查项
export const addSlopeInvestigate = params => post('/investigate/investigate-slope/v1/add',  params )

//删除排查小项
export const tagDelete = params => post('/investigate/investigate-slope/v1/delete',  params )



// 新增边坡排查记录
export const addSlopeInvestigation = params => post('/investigate/investigate-slope-order/v1/add',  params )
// 更新边坡排查记录
export const updateSlopeInvestigation = params => post('/investigate/investigate-slope-order/v1/update',  params )
// 获取边坡排查记录
export const getSlopeInvestigationList = params => get('/investigate/investigate-slope-order/v1/queryList', { params })


// 新增地质灾害排查记录
export const addGeologyInvestigation = params => post('/investigate/investigate-road-order/v1/add',  params )
// 更新地质灾害排查记录
export const updateGeologyInvestigation = params => post('/investigate/investigate-road-order/v1/update',  params )
// 获取地质灾害排查记录
export const getGeologyInvestigationList = params => get('/investigate/investigate-road-order/v1/queryList', { params })



// 获取边坡地图
export const getSlopeMapList = params => get('/road/slope-info/v1/map', { params })
// 获取边坡地图统计数据
export const getProportionStatistics = params => get('/statistics/investigate/v1/dangerCount', { params })


// 获取排查单id对应的操作记录
export const getInvestigateOperation = params => get('/investigate/investigate-operation/v1/queryById', { params })

// 获取待复核统计
export const getInvestigateCheckCount = params => get('/statistics/investigate/v1/checkCount', { params })
// 复核边坡排查
export const checkSlopeInvestigate = params => post('/investigate/investigate-slope-order/v1/check',  params )
// 复核地质排查
export const checkGeologyInvestigate = params => post('/investigate/investigate-road-order/v1/check',  params )



//获取排查单对应的多条整改通知单
export const getRectificationNoticeByInvestigateId = params => get('/investigate/rectification-notice/v1/queryListByInvestigateId',{ params })

//通知
export const advertisementAdd = params => post('/advertisement/advertisement/v1/add',  params )
export const advertisementUpdate = params => post('/advertisement/advertisement/v1/update',  params )
export const advertisementQuery = params => get('/advertisement/advertisement/v1/queryList',{ params })
export const buildUnitSelect = params => get('/advertisement/advertisement/v1/buildUnitSelect',{ params })

//意见反馈
export const feedbackList = params => get('/advertisement/feedback/v1/queryList',{ params })




